import { ListingType, PropertyType } from '@zg-rentals/ts-rental-manager-api-client';
import PropertiesConstants from './PropertiesConstants';

const LISTING_TYPES = {
  RENTAL: 'For Rent',
  ROOM: 'Room for Rent',
  SALE: 'For Sale',
} as const;

const PROPERTY_TYPES = {
  COMMUNITY: 'Entire Apartment Community',
  CONDO: 'Condo / Apartment Unit',
  MULTIPLEX: 'Apartment units',
  HOUSE: 'House',
  TOWNHOUSE: 'Townhome',
} as const;

const { RENTAL, ROOM, SALE } = LISTING_TYPES;
const { COMMUNITY, CONDO, HOUSE, MULTIPLEX, TOWNHOUSE } = PROPERTY_TYPES;

const LISTING_CODES_BY_TYPE = {
  [RENTAL]: 1,
  [SALE]: 2,
  [ROOM]: 5,
} as const;

const LISTING_CODE_TO_ENUM: Record<number, ListingType> = {
  1: ListingType.RENTAL,
  2: ListingType.SALE,
  5: ListingType.ROOM,
};

const PROPERTY_TYPES_BY_CODE: Record<number, string> = {
  1: COMMUNITY,
  2: COMMUNITY,
  3: COMMUNITY,
  5: CONDO,
  6: HOUSE,
  7: TOWNHOUSE,
};

const PROPERTY_TYPES_BY_ENUM: Record<string, string> = {
  CONDO: CONDO,
  DIVIDED: COMMUNITY,
  GARDEN: COMMUNITY,
  HOUSE: HOUSE,
  LARGE: COMMUNITY,
  MEDIUM: COMMUNITY,
  TOWNHOUSE: TOWNHOUSE,
};

const PROPERTY_CODES_BY_TYPE = {
  [COMMUNITY]: 1,
  [CONDO]: 5,
  [HOUSE]: 6,
  [MULTIPLEX]: 5,
  [TOWNHOUSE]: 7,
} as const;

const PROPERTY_CODE_TO_ENUM: Record<number, PropertyType> = {
  1: PropertyType.LARGE,
  5: PropertyType.CONDO,
  6: PropertyType.HOUSE,
  7: PropertyType.TOWNHOUSE,
};

const ERROR_CODE = {
  IS_MULTI_FAMILY_RESTRICTED: 'isMultiFamilyRestricted',
};
const PROPERTY_TABLE_COLUMNS = {
  ADDRESS: 'header-address',
  RENT: 'header-rent',
  POTENTIAL_TENANTS: 'header-potential-tenants',
  LEASES: 'header-leases',
  ACTIONS: 'header-actions',
} as const;

const RENT_TRIGGERS = {
  'Set up payments': 'setup_payments',
  'View payment': 'view_late_payments',
} as const;

const POTENTIAL_TENANTS_TRIGGERS = {
  'Enable applications': 'enable_applications',
  'List for rent': 'list_for_rent',
  'Edit listing': 'edit_listing',
} as const;

const LEASE_TRIGGERS = {
  'New lease': 'create_new_lease',
  'Upload a lease': 'create_new_lease',
  'View lease': 'view_leases',
  'View leases': 'view_leases',
  'Edit draft': 'edit_draft_lease',
  'View drafts': 'view_draft_lease',
  'Send for signing': 'send_for_signing',
  'Renewal options': 'lease_renewal_options',
  'View progress': 'view_signing_progress',
  'View and sign': 'view_and_sign',
} as const;

const FILTER_TRIGGERS = {
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ALL]: 'all_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ON_MARKET]: 'for_rent_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.OFF_MARKET]: 'off_market_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.AT_RISK]: 'at_risk_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ARCHIVED]: 'archived_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.FREE_BONUS_LISTINGS]: 'bonus_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.CLAIMED]: 'claimed_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.SPOTLIGHT]: 'spotlight_properties',
} as const;

const HOVER_TRIGGERS = {
  [PROPERTY_TABLE_COLUMNS.RENT]: 'rent_payments',
  [PROPERTY_TABLE_COLUMNS.POTENTIAL_TENANTS]: 'potential_tenants',
  [PROPERTY_TABLE_COLUMNS.LEASES]: 'leases',
} as const;

const PROPERTY_TABLE_TRIGGER_OBJECT_MAP = {
  RENT_TRIGGERS,
  POTENTIAL_TENANTS_TRIGGERS,
  LEASE_TRIGGERS,
  FILTER_TRIGGERS,
  HOVER_TRIGGERS,
} as const;

const SYNDICATION_OVERVIEW_STATUS = {
  INACTIVE: 'inactive',
  PUBLISHING: 'publishing',
  PUBLISHED: 'published',
  PARTIALLY_PUBLISHED: 'partiallyPublished',
  DECLINED: 'declined',
  WAITLISTED: 'waitlisted',
};

const PropertyConstants = {
  LISTING_TYPES,
  LISTING_CODES_BY_TYPE,
  LISTING_CODE_TO_ENUM,
  PROPERTY_TYPES,
  PROPERTY_TYPES_BY_CODE,
  PROPERTY_TYPES_BY_ENUM,
  PROPERTY_CODES_BY_TYPE,
  PROPERTY_CODE_TO_ENUM,
  ERROR_CODE,
  PROPERTY_TABLE_COLUMNS,
  PROPERTY_TABLE_TRIGGER_OBJECT_MAP,
  SYNDICATION_OVERVIEW_STATUS,
};

export default PropertyConstants;
